var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.storeBanner.bannerItem.length ? '' : 'shiftUp'},[[_c('headline',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"title":_vm.lang(_vm.$t(_vm.headline))}}),_vm._v(" "),_c('div',{staticClass:"index-promotion-wrapper",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":_vm.handleClick}})]],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b9fa428","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NswModule.vue
// module id = i9Wu
// module chunks = 6